import { styled } from '@mui/material/styles';
import { Box, Box as MuiBox, Typography } from '@mui/material';

export const CardContainer = styled(MuiBox)(({ theme }) => ({
  border: `2px solid ${theme.palette.secondary.light}`,
  borderRadius: '0.75rem',
  padding: '0.75rem',
  display: 'flex',
  flexDirection: 'column',
  gap: '1.0rem',
  width: '100%',
}));

export const CardLine = styled(MuiBox)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  color: theme.palette.common.white,
}));

export const MiddleSection = styled(MuiBox)({
  display: 'flex',
  flexDirection: 'column',
  gap: '0px',
});

export const TextOpacity = styled(Box)(({ theme }) => ({
  opacity: '0.5',
  color: theme.palette.common.white,
}));

export const StatusText = styled(Typography)(() => ({
  fontWeight: 500,
  fontStyle: 'bold',
  fontSize: '0.55rem',
}));

interface StatusBadgeProps {
  background: string;
  textColor: string;
}

export const StatusBadge = styled(MuiBox)<StatusBadgeProps>(({ background, textColor }) => ({
  backgroundColor: background,
  color: textColor,
  padding: '0.15rem 0.25rem',
  borderRadius: '4px',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  whiteSpace: 'nowrap',
}));